import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CampaignAddEditStateType } from 'features/CampaignAndDiscount/@types/campaignAddEdit'

const initialState: CampaignAddEditStateType = {
  isLoading: false,
}

export const SLICE_NAME = 'campaignAddEdit'

const campaignList = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export default campaignList.reducer
export const { reset, setLoading } = campaignList.actions
